import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'

import { ImageComponent } from './components/image/image.component'
import { LoaderComponent } from './components/loader'
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component'
import { QuantityPickerAnimatedComponent } from './components/quantity-picker-animated'
import { QuantityPickerComponent} from './components/quantity-picker/quantity-picker.component'
import { FormErrorComponent } from './components/form-error/form-error.component'
import { FormValidationComponent } from './components/form-validation/form-validation.component'
import { ProductTileComponent } from './components/product-tile'
import { ProductAttributeComponent } from './components/product-attribute'
import { ProductsComponent } from './components/products'
import { AddCartComponent } from './components/add-cart'
import { MenuComponent } from './components/menu/menu.component'
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component'

import { FillerPipe } from './pipes/filler.pipe'
import { PricePipe } from './pipes/price.pipe'
import { SafeUrlPipe } from './pipes/safe-url.pipe'
import { DpDatePickerModule } from 'ng2-date-picker'
import { SplitTranslationPipe } from './pipes/split-translation.pipe'
import { FacetValuesPipe } from './pipes/facet-values.pipe'

import { DynamicOutlet } from './directives/dynamic-outlet'
import { DisableSubmitDirective } from './directives/disable-submit.directive'
import { CollapseDirective } from './directives/collapse.directive'
import { CollapseTriggerDirective } from './directives/collapse-trigger.directive'

import { MenuControlService } from './services/menu.service'
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { PageDecorationComponent } from './components/page-decoration/page-decoration.component';
import { BannerComponent } from './components/banner/banner.component'
import { BlocksComponent } from './components/blocks/blocks.component'
import { BlockComponent } from './components/block/block.component'
import { PageTextComponent } from './components/page-text/page-text.component'
import { ContainerBase } from '../core/base/container-base';
import { PopoverDirective } from './directives/popover.directive';
import { PopoverComponent } from './components/popover/popover.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductListItemComponent } from './components/product-list-item/product-list-item.component';
import { AddCartButtonComponent } from './components/add-cart-button/add-cart-button.component'
import { ViewTypeSwitchComponent } from './components/view-type-switch/view-type-switch.component';
import { ButtonComponent } from './components/button/button.component';
import { DynamicComponentHost } from './components/dynamic-component-host/dynamic-component-host.component'
import { ModalGalleryModule } from 'angular-modal-gallery';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LanguagePickerComponent } from './components/language-picker/language-picker.component';
import { LayoutModule } from '@angular/cdk/layout';
import { ScrollbarModule } from 'ngx-scrollbar';
import { TenantService } from './services/tenant.service';
import { HierarchicalMenuComponent } from './components/hierarchical-menu/hierarchical-menu.component';
import { MenuAccordionGroupComponent } from './components/menu-accordion-group/menu-accordion-group.component';
import { MenuAccordionComponent } from './components/menu-accordion/menu-accordion.component';
import { OnlyInStockComponent } from './components/only-in-stock';
import { AnalyticsService } from './services/analytics.service';
import { ProductsLoaderComponent } from './components/products-loader/products-loader.component';
import { FlyToCartDirective } from './directives/fly-to-cart.directive';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { FlyToCartService } from './services/fly-to-cart.service';
import { OrderByPipe } from './pipes/orderby.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { MomentDateFormat } from './pipes/moment-pipe';
import { ProductTableComponent } from './components/product-table/product-table.component';
import { ProductTableItemComponent } from './components/product-table-item/product-table-item.component';
import { ListMenuComponent } from './components/list-menu/list-menu.component';
import { MegaMenuComponent } from './components/mega-menu/mega-menu.component';
import { MegaMenuBlockComponent } from './components/mega-menu-block/mega-menu-block.component';
import { EmbeddedVideoComponent } from './components/embedded-video/embedded-video.component';
import { BlocksGroupComponent } from './components/blocks-group/blocks-group.component';
import { StockInfoComponent } from './components/stock-info/stock-info.component';
import { FilterGroupComponent } from './components/filter-group/filter-group.component';
import { FilterGroupListComponent } from './components/filter-group-list/filter-group-list.component';
import { FilterItemComponent } from './components/filter-item/filter-item.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LayoutModule,
    FormsModule,
    ModalGalleryModule,
    ReactiveFormsModule,
    DpDatePickerModule,
    InfiniteScrollModule,
    TranslateModule,
    ScrollbarModule
  ],
  declarations: [
    ImageComponent,
    LoaderComponent,
    BreadcrumbsComponent,
    FillerPipe,
    PricePipe,
    SafeUrlPipe,
    OrderByPipe,
    NumberFormatPipe,
    MomentDateFormat,
    SplitTranslationPipe,
    FacetValuesPipe,
    QuantityPickerAnimatedComponent,
    QuantityPickerComponent,
    DynamicOutlet,
    DisableSubmitDirective,
    FormErrorComponent,
    FormValidationComponent,
    ProductTileComponent,
    ProductAttributeComponent,
    ProductsComponent,
    AddCartComponent,
    CollapseDirective,
    MenuComponent,
    PageNotFoundComponent,
    CollapseTriggerDirective,
    DatePickerComponent,
    PageDecorationComponent,
    BannerComponent,
    BlocksComponent,
    BlockComponent,
    PageTextComponent,
    ContainerBase,
    PopoverDirective,
    PopoverComponent,
    ProductListComponent,
    ProductListItemComponent,
    AddCartButtonComponent,
    ViewTypeSwitchComponent,
    ButtonComponent,
    DynamicComponentHost,
    NavbarComponent,
    LanguagePickerComponent,
    HierarchicalMenuComponent,
    MenuAccordionGroupComponent,
    MenuAccordionComponent,
    OnlyInStockComponent,
    ProductsLoaderComponent,
    FlyToCartDirective,
    DebounceClickDirective,
    ProductTableComponent,
    ProductTableItemComponent,
    ListMenuComponent,
    MegaMenuComponent,
    MegaMenuBlockComponent,
    EmbeddedVideoComponent,
    BlocksGroupComponent,
    StockInfoComponent,
    FilterGroupComponent,
    FilterGroupListComponent,
    FilterItemComponent
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DpDatePickerModule,
    InfiniteScrollModule,
    TranslateModule,
    ImageComponent,
    LoaderComponent,
    BreadcrumbsComponent,
    FillerPipe,
    PricePipe,
    SafeUrlPipe,
    OrderByPipe,
    NumberFormatPipe,
    MomentDateFormat,
    SplitTranslationPipe,
    FacetValuesPipe,
    LayoutModule,
    QuantityPickerAnimatedComponent,
    QuantityPickerComponent,
    DynamicOutlet,
    DisableSubmitDirective,
    FormErrorComponent,
    FormValidationComponent,
    ProductTileComponent,
    ProductAttributeComponent,
    ProductsComponent,
    AddCartComponent,
    CollapseDirective,
    CollapseTriggerDirective,
    MenuComponent,
    PageNotFoundComponent,
    DatePickerComponent,
    PageDecorationComponent,
    BannerComponent,
    BlocksComponent,
    BlockComponent,
    PageTextComponent,
    ContainerBase,
    AddCartButtonComponent,
    ViewTypeSwitchComponent,
    ButtonComponent,
    PopoverComponent,
    PopoverDirective,
    NavbarComponent,
    LanguagePickerComponent,
    ScrollbarModule,
    HierarchicalMenuComponent,
    MenuAccordionGroupComponent,
    MenuAccordionComponent,
    OnlyInStockComponent,
    ProductsLoaderComponent,
    FlyToCartDirective,
    DebounceClickDirective,
    ProductTableComponent,
    ProductTableItemComponent,
    ListMenuComponent,
    MegaMenuComponent,
    MegaMenuBlockComponent,
    EmbeddedVideoComponent,
    BlocksGroupComponent,
    StockInfoComponent,
    FilterGroupComponent,
    FilterGroupListComponent,
    FilterItemComponent,
  ],
  providers: [
    MenuControlService,
    AnalyticsService,
    FlyToCartService,
    TenantService,
    PricePipe,
    FacetValuesPipe,
    SafeUrlPipe
  ]
})
export class SharedModule
{ }
